import React, { useContext, useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import Select from 'react-select';
import axios from 'axios';
import { abstartOldUrl } from '../../Constants/constants';
// import jsPDF from "jspdf";
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";
import { ConfigContext } from '../../Context/ConfigContext';
import { NoRecords } from '../../Components/Shimmer';
import { formatDate, formatMonthYear, SubmitButton } from '../../Components/InputElements';
// import 'bootstrap/dist/css/bootstrap.min.css';


function PaySlipSandbox(props) {
    const { apiURL, apiHeaderFile, apiHeaderJSON } = useContext(ConfigContext);
    const [loading, setLoading] = useState(false);
    const [loadingRows, setLoadingRows] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [download, setDownload] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [payslipShow, setPayslipShow] = useState([]);
    const [payslip, setPayslip] = useState(false);
    const [payslipType, setPayslipType] = useState(false);
    const [monthOptions, setMonthOptions] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [allMonthsData, setAllMonthsData] = useState([]);
    const [rows, setRows] = useState([]);
    function getList() {
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Home/GetPaySlipList`, {
                params: {
                    employeeCode: localStorage.getItem("employee_code_emp"),
                    year: selectedMonth,
                },
                headers,
            })
            .then((response) => {
                // console.log("response?.data?.data;",response?.data);
                const { success, data } = response?.data?.data;
                // console.log("getPayslip ==>", response);
                if (success === true) {
                    setRows(data);
                    // console.log("show_old_payslips",show_old_payslips);
                    setPayslipShow(response?.data?.show_old_payslips);
                }else{
                    setRows([]);
                }
                setLoading(false);
                setLoadingFilter(false);
                setLoadingRows(false);
            })
            .catch((error)=>{
                console.error(error);
                setLoading(false);
                setLoadingFilter(false);
                setLoadingRows(false);
            });
    }
    function getOldList() {
        axios.get(`${abstartOldUrl}pages/api/v1/payslip/list`,{
            params:{
                token: "asdf",
                emp_code: localStorage.getItem("employee_code_emp"),
                salary_month_year: selectedMonth,
            }
        })
        .then((response)=>{
            const data= response?.data;
            // console.log("pages/api/v1/payslip/list", data);
            const options= data?.data?.map((val)=>{
                return {value: val?.salary_month_year, label: val?.salary_month_year}
            });
            // console.log(options);
            // console.log(data?.data);
            setAllMonthsData(options);
            setRows(data?.data);
            setLoading(false);
            setLoadingRows(false);
            setLoadingFilter(false);
        })
        .catch((error)=>{
            setRows([]);
            console.error(error);
            setLoading(false);
            setLoadingRows(false);
            setLoadingFilter(false);
        })
    }
    // get payslip months
    function getPayslipByMonth() {

        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Home/GetPaySlipMonthYear`, {
                params: {
                    employeeCode: localStorage.getItem("employee_code_emp")
                },
                headers,
            })
            .then((response) => {
                const { success, filterData } = response.data;
                // console.log("getPayslipByMonth ==>", response);
                if (success === true) {
                    setMonthOptions(filterData);
                }
            }).catch((error) => {
                console.log('getPayslipByMonth => ERROR: ', error);
            });
    }

    useEffect(() => {
        // getPayslip();
        setLoading(true);
        if(payslipType){
            getOldList();
        }else{
            console.log("getList Called");
            getList();
        }
        getPayslipByMonth();
    }, []);

    useEffect(() => {
        if(isChanged){
            if(payslipType){
                console.log("1",isChanged);
                getOldList();
            }else{
                console.log("2",isChanged);
                console.log("getList Called");
                getList();
            }
            setIsChanged(false);
        }
    }, [isChanged]);
    // download payslip pdf function
    // const payslipFilter = () => {
    //     try {
    //         setLoadingFilter(true);
    //         let temp = allMonthsData?.filter((val) => {
    //             console.log(val?.salary_month_year, selectedMonth)
    //             if (val?.salary_month_year === selectedMonth) {
    //                 return val;
    //             }
    //         });
    //         console.log("====>>>>temp", temp);
    //         setMonthOptions(temp);
    //         setLoadingFilter(false)
    //     } catch (error) {
    //         setLoadingFilter(false);
    //     }
    // }

    // const handleChange = (name, value) => {
    //     setFilter({ ...filter, [name]: value });
    // }

    function handleClearAll() {
        setSelectedMonth("");
        setIsChanged(true);
    }
    // const downloadButton = async (emp_code, salary_month, salary_year) => {
    //     setLoadingDownload(emp_code);
    //     try {
    //         const response = await fetch(`${abstartOldUrl}pages/api/v1/payslip/download?token=654&emp_code=${localStorage.getItem("employee_code_emp")}&who_is=employee&salary_month=${salary_month}&salary_year=${salary_year}`);
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }
    //         const blob = await response.blob();
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = `${emp_code.replace(/ /g, "_")}_${salary_month}-${salary_year}_${new Date().toISOString().split("T")[0]}.pdf`;
    //         document.body.appendChild(a);
    //         a.click();
    //         document.bodyNaNpxoveChild(a);
    //         window.URL.revokeObjectURL(url); // Cleanup the URL object
    //         setLoadingDownload(false);
    //         setDownload(false);
    //     } catch (error) {
    //         console.error('There was a problem with the download:', error);
    //         setLoadingDownload(false);
    //         setDownload(false);
    //     }
    // }

    const [payslipLeaveData, setPayslipLeaveData] = useState();
    const [payslipEarning, setPayslipEarning] = useState();
    const [payslipDeduction, setPayslipDeduction] = useState();
    const [response, setResponse] = useState();

    const downloadPayslip2 = (month) => {
        let payslip;
        let payslipLeaveData;
        let payslipEarning;
        let payslipDeduction;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetPaySlip`, {
                params: {
                    month: month,
                    employeeCode: localStorage.getItem("employee_code_emp")
                },
                headers,
            })
            .then(async (response) => {
                const { success, employee_data, earning_data, deduction_data, leave_data, pdfBlob } = response.data;
                // const { success, pdfBlob} = response.data;
                // const { success, mdFile, pdfBlob} = response.data;
                console.log("getPayslip ==>", response?.data);
                // console.log("pdfBlob ==>", pdfBlob);
                if (success) {
                    payslip = employee_data[0];
                    console.log("GetPaySlip => leave_data",leave_data);
                    payslipLeaveData = leave_data;
                    payslipEarning = earning_data;
                    payslipDeduction = deduction_data;
                    const maxRows = Math.max(payslipEarning.length, payslipDeduction.length);
                    const earningRows = payslipEarning.length;
                    const deductionRows = payslipDeduction.length;

                    // Add empty rows to the shorter table
                    const emptyRowsEarning = new Array(maxRows - earningRows).fill({ salary_head_name_for_payslip: '', company_salary_head_value: '' });
                    const emptyRowsDeduction = new Array(maxRows - deductionRows).fill({ salary_head_name_for_payslip: '', company_salary_head_value: '' });

                    payslipEarning = payslipEarning.concat(emptyRowsEarning);
                    payslipDeduction = payslipDeduction.concat(emptyRowsDeduction);
                    setPayslip(employee_data[0]);
                    setPayslipLeaveData(leave_data);
                    setPayslipEarning(earning_data);
                    setPayslipDeduction(deduction_data);
                    setResponse(response.data);
                    // display: flex; justify-content: start; align-items: center; gap:1.2rem;
                    // display: grid; grid-template-columns: 1fr 4fr; justify-content: center; align-items: center;
                    //  style="display: flex; justify-content: center; flex-direction:column; align-items: start;"
                    const payslipContent = `
                        <div style="font-family: Arial, sans-serif; max-width: 1900px; padding: 5px; line-height: 1.4;">
                        <div style="display: grid; grid-template-columns: 1fr 4fr; justify-content: center; align-items: center; margin-bottom: 7px;">
                            <div style="min-width=50px; max-width=200px; width:100%;" >
                                ${payslip?.company_name ? `<img style="max-width: 150px; width: 100%;" src="/img/abstart-logo.png" alt="Company Logo"/>` :
                            `<div style="display: flex; justify-content: center; align-items: center; background-color: #f2f2f2; width: 50px; height: 50px; border-radius: 10px;">
                                    <img style="max-width: 150px; width: 100%;" src="/img/placeholder-logo.png" alt="Company Logo"/>
                                </div>`}
                            </div>
                            <div style="display: flex; justify-content: center; flex-direction:column; align-items: center;">
                                <h4 style="text-align: center; color: rgb(16 92 255); font-size: 1.2rem; margin:0px">${payslip?.company_name || ''}</h4>
                                <p style="font-size: 0.6rem; text-align: center; color: #555; margin-bottom: 0px;"><strong>${payslip?.registered_office_address || ''}</strong></p>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; margin-bottom: 20px;">

                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Payslip for the month:</strong>
                            <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${response?.data?.month_year ? formatMonthYear(response?.data?.month_year) : ""}</p>
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Designation:</strong>
                            <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.designation_title || ''}</p>
                            </div>

                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Emp Code:</strong>
                            <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_code || ''}</p>
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Location:</strong>
                            <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.location_title || ''}</p>
                            </div>

                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Employee Name:</strong>
                            <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_name || ''}</p>
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Department:</strong>
                            <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.department_title || ''}</p>
                            </div>

                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Joining Date:</strong>
                            <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_joining_date ? formatDate(payslip?.employee_joining_date) : ''}</p>
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">ESIC No.:</strong>
                            <p style="color: #1d9704; font-size: 0.62rem;"></p>
                            </div>

                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Group Join Date</strong>
                            <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;"></p>
                            </div>

                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">UAN No.:</strong>
                            <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;"></p>
                            </div>

                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Acc No</strong>
                            <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_bank_account_number || ""}</p>
                            </div>

                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">IFSC</strong>
                            <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_bank_Ifsc || ""}</p>
                            </div>
                        </div>                       
                        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; margin: 5px 0;">
                            <div>
                                <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
                                    <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Days Paid:</strong>
                                    <p style=" font-size: 0.62rem; margin-bottom:0.3rem;">${response?.data?.payable_days}</p>
                                </div>
                            </div>
                            <div>
                                <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
                                <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Days Present:</strong>
                                <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${response?.data?.present_days}</p>
                                </div>
                            </div>
                            <div>
                                <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
                                    <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">LWP/Absent:</strong>
                                    <p style=" font-size: 0.62rem; margin-bottom:0.3rem;">${response?.data?.LOP_days}</p>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; margin: 5px 0;">
                            ${payslipLeaveData
                                ?.map((leave) =>
                                    Object.entries(leave)
                                        .map(([key, value]) => `
                                            <div>
                                                <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                                                <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
                                                    <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">${key}:</strong>
                                                    <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${value}</p>
                                                </div>
                                            </div>
                                        `)
                                        .join('')
                                )
                                .join('')}
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; margin-top:2rem;">
                            <div>
                            <table style="width: 100%; border-collapse: collapse; font-size: 0.62rem;">
                                <thead>
                                <tr style="background-color: #f2f2f2;">
                                    <th style="border: 1px solid #ddd; padding: 6px;">Earnings</th>
                                    <th style="border: 1px solid #ddd; padding: 6px;">Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                ${payslipEarning?.map(earning => `
                                    <tr style="height: 1.75rem">
                                    <td style="border: 1px solid #ddd; padding: 6px;">${earning.salary_head_name_for_payslip}</td>
                                    <td style="border: 1px solid #ddd; padding: 6px;">${earning.company_salary_head_value}</td>
                                    </tr>`).join('')}
                                <tr style="height: 1.75rem">
                                    <td style="border: 1px solid #ddd; padding: 6px;"><strong>Total Amount</strong></td>
                                    <td style="border: 1px solid #ddd; padding: 6px;"><strong>${response?.data?.total_earned_gross}</strong></td>
                                </tr>
                                </tbody>
                            </table>
                            </div>

                            <div>
                            <table style="width: 100%; border-collapse: collapse; font-size: 0.62rem;">
                                <thead>
                                <tr style="background-color: #f2f2f2;">
                                    <th style="border: 1px solid #ddd; padding: 6px;">Deductions & Recoveries</th>
                                    <th style="border: 1px solid #ddd; padding: 6px;">Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                ${payslipDeduction?.map(deduction => `
                                    <tr style="height: 1.75rem">
                                    <td style="border: 1px solid #ddd; padding: 6px;">${deduction.salary_head_name_for_payslip}</td>
                                    <td style="border: 1px solid #ddd; padding: 6px;">${deduction.company_salary_head_value}</td>
                                    </tr>`).join('')}
                                <tr style="height: 1.75rem">
                                    <td style="border: 1px solid #ddd; padding: 6px;"><strong>Total Amount</strong></td>
                                    <td style="border: 1px solid #ddd; padding: 6px;"><strong>${response?.data?.total_deduction}</strong></td>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>

                        <table style="width: 100%; border-collapse: collapse; margin-top: 1rem; font-size: 0.63rem;">
                            <tbody>
                            <tr>
                                <td style="border: 1px solid #ddd;">
                                <p style=" margin-bottom: 0;" class="px-3 py-1"><strong>Net Pay: ${response?.data?.total_net_pay}</strong></p>
                                </td>
                            </tr>
                            <tr>
                                <td style="border: 1px solid #ddd;">
                                <p style=" margin-bottom: 0;" class="px-3 py-1"><strong>In Words: ${response?.data?.total_net_pay_in_word}</strong></p>
                                </td>
                            </tr>
                            <tr>
                                <td style="border: 1px solid #ddd;">
                                <p style="color: #777; margin-bottom: 0; font-size: 0.6rem " class="px-3 py-1">This payslip is computer generated and does not require a signature.</p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    `;

                    // const markdownContent = mdFile;
                    // // Create a Blob for the Markdown file
                    // const blob = new Blob([markdownContent], { type: 'text/markdown' });
                    // const url = window.URL.createObjectURL(blob);
                    
                    // // Create a link element to trigger the download
                    // const a = document.createElement('a');
                    // a.href = url;
                    // a.download = 'payslip.md'; // File name
                    // document.body.appendChild(a);
                    // a.click();
                    // document.body.removeChild(a);
                    // window.URL.revokeObjectURL(url);

                     // Create a URL for the blob object
                    // const url = window.URL.createObjectURL(new Blob([response.data]));

                    // // Create a temporary <a> element to trigger the download
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', 'payslip.pdf');
                    // document.body.appendChild(link);
                    // link.click();

                    // // Clean up resources
                    // window.URL.revokeObjectURL(url);
                    // document.body.removeChild(link);
                    // old code
                    // const blob = new Blob([response?.data], { type: 'application/pdf' });
                    // const url = window.URL.createObjectURL(blob);
                    // const a = document.createElement('a');
                    // a.href = url;
                    // a.download = `payslip.pdf`;
                    // document.body.appendChild(a);
                    // a.click();
                    // document.body.removeChild(a);
                    // window.URL.revokeObjectURL(url);

                    const options = {
                        margin: 0.5,
                        filename: `${localStorage.getItem("employee_code_emp")} ${payslip?.employee_name} ${response?.data?.month_year}.pdf`,
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2 },
                        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
                    };

                    // Generate PDF
                    html2pdf().from(payslipContent).set(options).save();
                }
                console.log("loadingDownload 3");
                setLoadingDownload(false);
                setDownload(false);
            }).catch((error) => {
                console.log("error",error);
                console.log("loadingDownload 4");
                setLoadingDownload(false);
                setDownload(false);
            });
    };
    
    // const downloadOldButton = async (emp_code, salary_month, salary_year) => {
    //         try {
    //             const response = await fetch(`${abstartOldUrl}pages/api/v1/payslip/download?token=654&emp_code=${localStorage.getItem("employee_code_emp")}&who_is=employee&salary_month=${salary_month}&salary_year=${salary_year}`);
    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok');
    //             }
    //             console.log("response",response);
    //             const blob = await response.blob();
    //             const url = window.URL.createObjectURL(blob);
    //             const a = document.createElement('a');
    //             a.href = url;
    //             a.download = `${emp_code.replace(/ /g, "_")} ${salary_month}-${salary_year}.pdf`;
    //             document.body.appendChild(a);
    //             a.click();
    //             document.bodyNaNpxoveChild(a);
    //             setTimeout(() => {
    //                 document.body.removeChild(a);
    //                 window.URL.revokeObjectURL(url);
    //                 setLoadingDownload(false);
    //                 setDownload(false);
    //             }, 3000);
    //         } catch (error) {
    //             console.error('There was a problem with the download:', error);
    //             setLoadingDownload(false);
    //             setDownload(false);
    //         }
    //     }
// ------------------------------------------------------------------------------------------------------------------
    // this API called Old abstart and old ABStart called New ABStart to get data
    const downloadPayslip = (salary_month_year) => {
        const headers = apiHeaderJSON;
        const employeeCode= localStorage.getItem("employee_code_emp")
        console.log("salary_month_year",salary_month_year);
        const payslip_response_data_type = "blob";
        const options = {
            params: {
                month: salary_month_year,
                is_uat: apiURL === "https://uatempapi.abstarthr.in/" ? "1" : false,
                payslip_data_type: payslip_response_data_type,
                ...headers
            },
            headers,
        }
        if (payslip_response_data_type === "blob") {
            options.responseType = "blob";
        }
        // axios.get(`${abstartOldUrl}pages/api/v1/payslip/download`, {
        axios.get(`${apiURL}Home/GetPaySlip`, options)
        .then((response) => {
            console.log("response", response);
            const contentType = response.headers['content-type'];
            console.log("contentType",contentType)
            if (contentType && contentType.includes('application/json')) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const json = JSON.parse(reader.result);
                        console.log('json',json)
                        if (json?.success === false) {
                            Swal.fire({
                                title: `<strong>Failed</strong>`,
                                text: json.message || "Something went wrong!",
                                icon: 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            });
                        }
                    } catch (err) {
                        console.error("Failed to parse JSON from blob:", err);
                    }
    
                    setLoadingDownload(false);
                    setDownload(false);
                };
                reader.readAsText(response.data);
                return;
            }
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${employeeCode.replace(/ /g, "_")} ${salary_month_year}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            console.log("loadingDownload new 1");
            setLoadingDownload(false);
            setDownload(false);
        })
        .catch((error) => {
            console.error('There was a problem with the download:', error);
            console.log("loadingDownload new 2");
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: error,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick:false,
            });
            setLoadingDownload(false);
            setDownload(false);
        });
    };
// ------------------------------------------------------------------------------------------------------------------
    // const downloadPayslip = (salary_month_year) => {
    //     const headers = apiHeaderJSON;
    //     const employeeCode= localStorage.getItem("employee_code_emp")
    //     console.log("salary_month_year",salary_month_year);
    //     // axios.get(`${abstartOldUrl}pages/api/v1/payslip/download`, {
    //     axios.get(`${abstartOldUrl}pages/api/v1/new-abstart/payslip/download`, {
    //         params: {
    //             month: salary_month_year,
    //             is_uat: apiURL === "https://uatempapi.abstarthr.in/" ? "1" : false,
    //             ...headers
    //         },
    //         headers,
    //         responseType: 'blob',
    //     })
    //     .then((response) => {
    //         console.log("response", response);
    //         const contentType = response.headers['content-type'];

    //         if (contentType && contentType.includes('application/json')) {
    //             const reader = new FileReader();
    //             reader.onload = () => {
    //                 try {
    //                     const json = JSON.parse(reader.result);
    //                     if (json?.success === false) {
    //                         Swal.fire({
    //                             title: `<strong>Failed</strong>`,
    //                             text: json.message || "Something went wrong!",
    //                             icon: 'error',
    //                             showConfirmButton: true,
    //                             allowOutsideClick: false,
    //                         });
    //                     }
    //                 } catch (err) {
    //                     console.error("Failed to parse JSON from blob:", err);
    //                 }
    
    //                 setLoadingDownload(false);
    //                 setDownload(false);
    //             };
    //             reader.readAsText(response.data);
    //             return;
    //         }
    //         const blob = new Blob([response.data], { type: 'application/pdf' });
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = `${employeeCode.replace(/ /g, "_")} ${salary_month_year}.pdf`;
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);
    //         window.URL.revokeObjectURL(url);
    //         console.log("loadingDownload new 1");
    //         setLoadingDownload(false);
    //         setDownload(false);
    //     })
    //     .catch((error) => {
    //         console.error('There was a problem with the download:', error);
    //         console.log("loadingDownload new 2");
    //         Swal.fire({
    //             title: `<strong>Failed</strong>`,
    //             text: error,
    //             icon: 'error',
    //             showConfirmButton: true,
    //             allowOutsideClick:false,
    //         });
    //         setLoadingDownload(false);
    //         setDownload(false);
    //     });
    // };

    const downloadOldButton = (emp_code, salary_month, salary_year) => {
        axios.get(`${abstartOldUrl}pages/api/v1/payslip/download`, {
            params: {
                token: "654",
                emp_code: localStorage.getItem("employee_code_emp"),
                who_is: "employee",
                salary_month: salary_month,
                salary_year: salary_year
            },
            responseType: 'blob'
        })
        .then((response) => {
            console.log("response", response);
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${emp_code.replace(/ /g, "_")} ${salary_month}-${salary_year}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            console.log("loadingDownload 1");
            setLoadingDownload(false);
            setDownload(false);
        })
        .catch((error) => {
            console.error('There was a problem with the download:', error);
            console.log("loadingDownload 2");
            setLoadingDownload(false);
            setDownload(false);
        });
    };
    console.log("payslipShow",payslipShow);
    useEffect(()=>{
        console.log("loadingDownload",loadingDownload)
    },[loadingDownload])




    return (
        <>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Payslip`} primary={`My Details`} />
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-md-3 position-relative mb-5">
                                                <div><label>Year</label></div>
                                                <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                    <Select onChange={(selectedOption) => setSelectedMonth(selectedOption?.value)}
                                                    options={payslipType? allMonthsData : monthOptions}
                                                    placeholder={`Select Year`}
                                                    value={selectedMonth ? payslipType? allMonthsData.find(option => option.value === selectedMonth) : monthOptions.find(option => option.value === selectedMonth) : null}/>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-3">
                                                <div className="row"> */}
                                                    <div className="col-lg-2 col-md-3 col-6 ">
                                                        <div><label>Apply Filter</label></div>
                                                        <SubmitButton otherClasses='w-100 noWrap' onClick={(e)=>{ 
                                                        setLoadingFilter("1");
                                                        if(payslipType){ setRows([]); getOldList(); }
                                                        else{ setRows([]); console.log("getList Called"); getList(); } }}
                                                        disabled={!selectedMonth} 
                                                        loading={loadingFilter==="1"} loadingMessage='Loading' 
                                                        buttonName={'Filter'} icon={'ri-filter-3-fill'}  type='info' iconSide='left' />
                                                    </div>
                                                    <div className="col-lg-2 col-md-3 col-6 ">
                                                        <div><label className=' text-nowrap'>Clear Filter</label></div>
                                                            <SubmitButton otherClasses='w-100 noWrap' onClick={(e)=>{  setLoadingFilter("2");  handleClearAll(); }}
                                                            disabled={!selectedMonth} 
                                                            loading={loadingFilter==="2"} loadingMessage='Loading' 
                                                            buttonName={'Clear'} icon={'ri-filter-3-fill'} type='secondary' iconSide='left' />
                                                    </div>
                                                {/* </div>
                                            </div> */}
                                            {payslipShow && (
                                                <div className="col-md-3">
                                                    <div><label className=' text-nowrap'>Payslips</label></div>
                                                    <SubmitButton onClick={(e)=>{  setLoadingRows(true); setPayslipType(!payslipType); setIsChanged(true);}}
                                                    disabled={loadingFilter || loadingRows || loadingDownload} 
                                                    loading={loadingRows} loadingMessage={"Loading"} 
                                                    buttonName={payslipType ? 'New Payslips':'Old Payslips'} icon={'ri-switch-line'} type='info' iconSide='left' />
                                                </div>
                                            )}
                                            
                                        </div>
                                    </div>

                                    <div id="example_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                                        {/* <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                                <div className="dataTables_length" id="example_length"><label>Show <select name="example_length" aria-controls="example" className="form-select form-select-sm">
                                                <option value={10}>10</option><option value={25}>25</option><option value={50}>50</option><option value={100}>100</option></select> entries</label>
                                            </div>
                                            </div>
                                        </div> */}
                                        <div>
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                <table id="example" className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed">
                                                    <thead class="bg-primary text-light bg-gradient sticky-top z-1">
                                                        <tr>
                                                        <th style={{ width:"5%"}} className=' text-center'>Sr.No.</th>
                                                            <th className='noWrap'>Employee Code</th>
                                                            <th className='noWrap'>Salary Month Year</th>
                                                            <th style={{ width:"15%"}} className=' text-center'>Action</th>
                                                        </tr>
                                                    </thead>
                                                    {rows?.length === 0 ?
                                                        (<tbody>
                                                            <tr>
                                                                <td colSpan={4}>
                                                                    <NoRecords />
                                                                </td>
                                                            </tr>
                                                        </tbody>) :
                                                        (<tbody>
                                                            {rows?.map((val, idx) => {
                                                                return (
                                                                    <tr key={val?.salary_month_year || val?.formatted_month_year} className="">
                                                                        <td>{idx + 1}</td>
                                                                        <td>{val?.emp_code || localStorage.getItem("employee_code_emp")}</td>
                                                                        <td>{val?.salary_month_year || val?.formatted_month_year}</td>
                                                                        {/* {!loadingDownload ?
                                                                            <td className=' text-center'><button type="button" className="btn btn-primary waves-effect wave-light bg-primary"
                                                                                onClick={(e) => { setDownload(val?.salary_month_year); downloadButton(val?.salary_month_year); }} >Download</button></td> :
                                                                                download == val?.salary_month_year ?
                                                                                <td className=' text-center'><button type="button" disabled className="btn btn-primary waves-effect wave-light bg-primary"
                                                                                >loading...</button></td> :
                                                                                <td className=' text-center'><button type="button" disabled className="btn btn-primary waves-effect wave-light bg-primary"
                                                                                >Download</button>
                                                                            </td>}*/}
                                                                        <td> 
                                                                            <SubmitButton onClick={(e)=>{ 
                                                                            setLoadingDownload(val?.salary_month_year || val?.formatted_month_year);
                                                                            setDownload(val?.salary_month_year || val?.formatted_month_year);
                                                                            if(payslipType){ downloadOldButton(val?.emp_code, val?.salary_month, val?.salary_year) }
                                                                            else{ downloadPayslip(val?.salary_month_year); } }}
                                                                            disabled={loadingDownload}
                                                                            loading={loadingDownload===val?.salary_month_year || loadingDownload === val?.formatted_month_year} loadingMessage={"Loading"}  
                                                                            buttonName={'Download'} icon={'ri-download-2-fill'} type='primary' iconSide='left' />
                                                                        </td>
                                                                    </tr> 

                                                                )
                                                            }) }
                                                        </tbody>) 
                                                    }

                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div >


                    </div>
                </div > :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </>
    );
}

export default PaySlipSandbox;